import { PlayerV7Config } from "./EmbedHelperV7";
/**
 * single media oembed url
 */
export default class Oembed {
    static template = "{HOST}/id/{ENTRY_ID}?width={WIDTH}&height={HEIGHT}&playerId={UICONF_ID}";

    /**
     * generate dynamic oembed url
     */
    static generateOembedUrl(
        host: string,
        playerV7Config: PlayerV7Config | undefined,
        size: string,
        playerId: string,
        startTime: number
    ) {
        if (!playerV7Config) {
            return "";
        }

        const sizes = size.split("x");
        const width = parseInt(sizes[0], 10);
        const height = parseInt(sizes[1], 10);

        let url = `${host}/id/${playerV7Config.entry_id}?width=${width}&height=${height}&playerId=${playerId}`;

        if (startTime !== 0) {
            url += `&st=${startTime}`;
        }

        return url;
    }
}
